<template>
  <div>
    <img id="image-preview" />
    <div class="file">
      <label class="file-label">
        <input
          class="file-input"
          type="file"
          name="resume"
          accept="image/*"
          @change="e => uploadImage(e.target)"
        />
        <span class="file-cta">
          <span class="file-icon">
            <i class="fas fa-image"></i>
          </span>
          <span class="file-label">
            Upload
          </span>
        </span>
      </label>
      <button class="button is-warning ml-1" @click="() => toggle(upload)">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadImage",
  props: {
    upload: { type: Boolean, default: () => false },
    itemType: { type: String, default: () => "logo" },
    index: { type: Number, default: () => -1 },
    isLogo: { type: Boolean, default: () => false },
    target: { type: String, default: () => "" }
  },
  methods: {
    toggle(value) {
      this.$emit("toggle", !value);
    },
    uploadImage(e) {
      if (e.files) {
        const files = e.files[0];
        const ext = files.name.split(".").pop();
        const filename = this.isLogo ? "logo." + ext : files.name;
        const formData = new FormData();
        formData.append("files", files);
        const dest = !this.isLogo ? "upload/" : "upload-logo/";
        axios
          .post(process.env.VUE_APP_SERVER + dest, formData)
          .then(res => {
            if (res.data.message.indexOf("Success") > -1) {
              this.$noty.success(this.itemType + " uploaded!");
              this.updateLogo(filename);
            }
          })
          .catch(error => {
            console.error(error);
            this.$noty.error(
              "There was a problem uploading your " + this.itemType + "."
            );
          });
      } else {
        this.$noty.warning("No image selected.");
      }
    },
    updateLogo(value) {
      this.toggle(this.upload);
      if (this.index < 0) {
        this.$emit("updateSettingsLogo", value);
      } else {
        const payload = { photo: value, index: this.index };
        if (this.target.length) payload.target = this.target;
        this.$emit("updateSettingsLogo", payload);
      }
    }
  }
};
</script>
